<template>
  <transition name="fade">
    <div v-if="loading" class="loading-overlay">
      <div class="loading-content">
        <!-- Animated logo or spinner -->
        <div class="loader-wrapper">
          <div class="loader-circle">
            <v-icon size="48" color="#28ea96" class="rotating-icon">
              fa-solid fa-spinner
            </v-icon>
          </div>
          <div class="loading-dots" v-if="false">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <!-- Loading text -->
        <div v-if="message" class="loading-message">
          <span>{{ message }}</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'Loading...'
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
#broker-app{
  .loading-overlay{
    position: fixed;
    min-height: 100vh;
    .loading-content{
      .loading-message{
        span{
          font-family: "Aeonik", sans-serif !important;
          color: black;
        }
      }
    }
  }
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);

  .loading-content {
    text-align: center;

    .loader-wrapper {
      position: relative;
      display: inline-block;

      .loader-circle {
        position: relative;
        display: inline-block;

        .rotating-icon {
          animation: rotate 2s linear infinite;
        }
      }

      .loading-dots {
        position: absolute;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 4px;

        span {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #28ea96;
          animation: pulse 1.5s ease-in-out infinite;

          &:nth-child(1) {
            animation-delay: 0s;
          }

          &:nth-child(2) {
            animation-delay: 0.2s;
          }

          &:nth-child(3) {
            animation-delay: 0.4s;
          }
        }
      }
    }

    .loading-message {
      margin-top: 32px;
      font-size: 14px;
      color: black;
      font-family: "Aeonik", sans-serif !important;
      font-weight: 500;
      animation: fadeInOut 2s ease-in-out infinite;
    }
  }
}

// Animations
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 60%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  30% {
    opacity: 1;
    transform: scale(1.2);
  }
}

@keyframes fadeInOut {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

// Transition
.fade-enter-active {
  transition: opacity 0.3s ease;
}

.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// Dark mode support
.theme--dark {
  .loading-overlay {
    background: rgba(0, 0, 0, 0.9);

    .loading-message {
      color: #aaa;
    }
  }
}
</style>